import { useEffect, Fragment } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Badge } from 'react-bootstrap';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber, sortTableDateFecha, sortTableDateFechaInicio } from '../../utils/generalFunctions';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { informacionAsesoria, limpiarAsesoria, detallesArchivo, limpiarArchivo } from '../../actions/asesorias';

import NuevoArchivo from './NuevoArchivo';
import EditarArchivo from './EditarArchivo';
import EliminarArchivo from './EliminarArchivo';

const DetallesAsesoria = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Asesorías',
            path: '/asesorias'
        },
        {
            activo: true,
            nombre: 'Detalles de la asesoría',
            path: '/asesorias/detalles/'
        }
    ];

    const dispatch = useDispatch();

    const { id } = useParams();

    const { usuario } = useSelector(state => state.auth);
    const { detalles, detalles_archivo } = useSelector(state => state.asesorias);

    /* Cliente */
    const [asesoriaData, setAsesoriaData] = useState({
        indicadores_generales: {
            contactos: 0,
            archivos: 0, 
            status: null
        },
        informacion_asesoria: {
            _id: null,
            motivo: null,
            descripcion : null,
            creacion: null,
            finalizacion: null,
            status: null
        },
        informacion_cliente: {
            _id: null,
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            nacimiento : null,
            celular: null,
            email: null,
            creacion: null,
            status: false, 
            empresa: {
                nombre_comercial: null, 
                razon_social: null, 
                rfc: null, 
                curp: null, 
                curp: null, 
                tipo_persona: null, 
                regimen_fiscal: null, 
                giro: null, 
                representante_legal: null, 
                puesto: null, 
                domicilio_fiscal: null, 
                telefono: null, 
                email: null, 
                web: null, 
                fecha_constitucion: null, 
                numero_empleados: null, 
                minimo_ingresos_anuales: null, 
                maximo_ingresos_anuales: null
            },
        },
        contactos: [], 
        archivos: []
    });

    /* Archivos */
    const [nuevoArchivo, setNuevoArchivo] = useState({
        asesoria: null
    });
    const [editarArchivo, setEditarArchivo] = useState(null);
    const [eliminarArchivo, setEliminarArchivo] = useState(null);

    const {indicadores_generales, informacion_asesoria, informacion_cliente, contactos, archivos} = asesoriaData;

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const contactosColumnas = [
        {
            name: 'Asesor',
            sortable: true, 
            selector: row => row.asesor ? [row.asesor.nombre, row.asesor.apellido_paterno, row.asesor.apellido_materno].join(' ') : 'Sin definir', 
            grow: 2
        },
        {
            name: 'Tipo',
            sortable: true, 
            selector: row => {
                switch(row.tipo){
                    case 0:
                        return 'Correo';
                    case 1:
                        return 'Llamada';
                    case 2:
                        return 'WhatsApp';
                    case 3:
                        return 'Presencial';
                    default:
                        break;
                }
            }
        }, 
        {
            name: 'Observaciones',
            sortable: true, 
            selector: row => row.observaciones || 'Sin definir', 
            grow: 4
        },
        {
            name: 'Fecha',
            sortable: true, 
            sortFunction: sortTableDateFecha, 
            cell: item => item.fecha ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(item.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir', 
            grow: 2
        }
    ];

    const archivosColumnas = [
        {
            name: 'Nombre',
            sortable: true, 
            grow: 2, 
            selector: row => row.nombre || 'Sin definir'
        },
        {
            name: 'Descripción',
            sortable: true, 
            grow: 2, 
            selector: row => row.descripcion || 'Sin definir'
        },
        {
            name: 'Tipo',
            sortable: true, 
            selector: row => row.extension ? row.extension.toUpperCase() : 'Sin definir'
        },
        {
            name: 'Fecha de carga',
            sortable: true, 
            sortFunction: sortTableDateFecha, 
            cell: item => item.fecha ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'
        }, 
        {
            name: '',
            grow: 1, 
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.asesorias?.archivos?.eliminar && indicadores_generales?.status == 0 &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarArchivo({ id_asesoria: id, id_archivo: row._id, nombre: row.nombre })}><i className="fas fa-times text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.archivos?.editar && indicadores_generales?.status == 0 &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarArchivo({ id_asesoria: id, id_archivo: row._id, ...row })}><i className="fas fa-edit text-primary"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.archivos?.detalles &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleDetallesArchivo({ id_asesoria: id, id_archivo: row._id })}><i className="fas fa-eye text-info"></i></button>
                        }
                    </div>
                )
            }
        }
    ];

    /* Archivos */
    const handleAgregarArchivo = (asesoria) => {
        setNuevoArchivo({
            asesoria
        });
    }

    const handleDetallesArchivo = (archivo) => {
        dispatch(detallesArchivo(archivo));
    }

    const handleAbrirArchivo = () => {
        if(!editarArchivo){
            window.open(detalles_archivo.url);
        }
    }

    const handleEditarArchivo = (asesoria) => {
        setEditarArchivo(asesoria);
    }

    const handleEliminarArchivo = (asesoria) => {
        setEliminarArchivo(asesoria);
    }

    /* Funciones generales */
    const handleStatus = (status) => {
        switch(status){
            case 0:
                return(
                    <Badge pill bg="warning">En curso</Badge>
                )
            case 1:
                return(
                    <Badge pill bg="success">Finalizada</Badge>
                )
            default:
                return(
                    <Badge pill bg="secondary">Sin definir</Badge>
                )
        }
    }

    useEffect(() => {
        dispatch(limpiarAsesoria());
        dispatch(limpiarArchivo());

        return () => {
            dispatch(limpiarAsesoria());
            dispatch(limpiarArchivo());
        }
    }, []);

    useEffect(() => {
        if(id){
            dispatch(informacionAsesoria(id));

            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        if(detalles){
            setAsesoriaData({
                ...asesoriaData,
                indicadores_generales: detalles.indicadores_generales, 
                informacion_asesoria: {
                    ...detalles.informacion_asesoria
                }, 
                informacion_cliente: {
                    ...detalles.informacion_cliente
                }, 
                contactos: detalles.informacion_asesoria?.historial || [], 
                archivos: detalles.informacion_asesoria?.archivos || []
            });
        }
    }, [detalles]);

    useEffect(() => {        
        if(detalles_archivo && detalles_archivo?.extension && detalles_archivo?.url){
            handleAbrirArchivo();
        }
    }, [detalles_archivo]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .btn-badge-status{
                            background-color: #fff;
                            border: none;
                            outline: none;
                            padding: 0;
                        }

                        .valor_indicador {
                            font-size: 40px;
                            margin: 0;
                        }

                        .descripcion_indicador {
                            margin: 0;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <NuevoArchivo archivo={nuevoArchivo} reestablecerArchivo={handleAgregarArchivo} />
            <EditarArchivo archivo={editarArchivo} reestablecerArchivo={handleEditarArchivo} />
            <EliminarArchivo archivo={eliminarArchivo} reestablecerArchivo={handleEliminarArchivo} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="title-section my-5">Detalles de la asesoría</h3>
                    
                    <div className="row mb-4">
                        <div className="col-md text-center">
                            <p className="valor_indicador subtitle-section">{ formatNumber(contactos.length, 0, '', '') }</p>
                            <p className="descripcion_indicador subtitle-section">Contactos</p>
                        </div>
                        <div className="col-md text-center">
                            <p className="valor_indicador subtitle-section">{ formatNumber(archivos.length, 0, '', '') }</p>
                            <p className="descripcion_indicador subtitle-section">Archivos</p>
                        </div>
                        <div className="col-md text-center">
                            <div className="mt-2 d-flex justify-content-center">
                                <h3 className="text-muted">
                                    { handleStatus(indicadores_generales?.status) }
                                </h3>
                            </div>
                            <p className="descripcion_indicador subtitle-section">Estado</p>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            <div className="accordion" id="accordionDetalles">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            Información de la asesoría
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-12">
                                                <label className="fw-bold">Motivo</label>
                                                <p>{informacion_asesoria?.motivo || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Asesor asignado</label>
                                                <p>{informacion_asesoria?.asesor ? [informacion_asesoria?.asesor?.nombre, informacion_asesoria?.asesor?.apellido_paterno, informacion_asesoria?.asesor?.apellido_materno].join(' ') : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Fecha de inicio</label>
                                                <p>{informacion_asesoria?.creacion ? new Date(informacion_asesoria?.creacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Fecha de finalización</label>
                                                <p>{informacion_asesoria?.finalizacion ? new Date(informacion_asesoria?.finalizacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="fw-bold">Descripción</label>
                                                <p>{informacion_asesoria?.descripcion || 'Sin definir'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                            Historial de contacto
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <DataTable
                                                columns={contactosColumnas}
                                                data={contactos}
                                                noDataComponent="No hay contactos registrados"
                                                pagination
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 20, 50]}
                                                paginationComponentOptions={paginationOptions}
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                            Expediente de archivos
                                        </button>
                                    </h2>
                                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body">
                                            <div className="col-md-12 text-end mb-3">
                                                {
                                                    usuario?.permisos?.asesorias?.archivos?.agregar && indicadores_generales?.status == 0 &&
                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                            <button type="button" className="btn btn-primary" onClick={() => handleAgregarArchivo(id)}><i className="fa-solid fa-plus"></i> Archivo</button>
                                                        </div>
                                                }                                                        
                                            </div>
                                            <DataTable
                                                columns={archivosColumnas}
                                                data={archivos}
                                                noDataComponent="No hay archivos registrados"
                                                pagination
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 20, 50]}
                                                paginationComponentOptions={paginationOptions}
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DetallesAsesoria;